export const IP_REGEX = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
export const NUMBER_FORMAT_REGEX = /^\d+\.\d{1,3}(\.\d{1,3})*$/;
export const DECIMAL_NUMBER_REGEX = /^(\d+(\.\d{1,5})?)$/;
export const PIN_LENGTH = 6;
